import { render, staticRenderFns } from "./bannerList.vue?vue&type=template&id=ba82fd6c&scoped=true&"
import script from "./bannerList.vue?vue&type=script&lang=js&"
export * from "./bannerList.vue?vue&type=script&lang=js&"
import style0 from "./bannerList.vue?vue&type=style&index=0&id=ba82fd6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba82fd6c",
  null
  
)

export default component.exports